export default {
  SET_PAGINATION(state, data) {
    state.pagination = data;
  },
  SET_TRANSACTION(state, transaction) {
    state.transaction = transaction;
  },
  SET_TRANSACTIONS(state, transactions) {
    state.transactions = transactions;
  },
  ADD_TRANSACTION(state, transaction) {
    state.transactions.push(transaction);
  },
  UPDATE_TRANSACTION(state, transaction) {
    const certIndex = state.transactions.findIndex(
      e => e.id === transaction.id
    );
    Object.assign(state.transactions[certIndex], transaction);
  },
  DELETE_TRANSACTION(state, itemId) {
    const certIndex = state.transactions.findIndex(u => u.id === itemId);
    state.transactions.splice(certIndex, 1);
  }
};
